@if (isTwitterDialogOpen) {
  <div class="twitter-dialog">
    <div class="twitter-header">
      <span>Twitter Search</span>
      <button class="close-btn" (click)="closeDialog()">×</button>
    </div>
    <div class="twitter-body">
      <div class="search-options">
        <!-- Icons can be replaced with real icons or font-awesome -->
        @for (option of searchOptions; track option) {
          <span class="option-icon" [class.selected]="selectedOption === option" (click)="selectOption(option)">
            {{ option.icon }}
          </span>
        }
        <input type="text" [(ngModel)]="keyword" placeholder="Keyword" />
        <select [(ngModel)]="dayCount">
          @for (day of days; track day) {
            <option [value]="day">{{ day }}</option>
          }
        </select>
        <button class="search-btn" (click)="searchTweets()">
          🔍
        </button>
      </div>
      <p class="info-text">search within the visible map area on screen</p>
      @if (!keyword) {
        <p class="enter-keyword">Please enter keywords to search.</p>
      }
    </div>
  </div>
}
